module.exports = __webpack_public_path__ + "static/img/login_bg.9cb0344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginImages/login_bg.png
// module id = BXLO
// module chunks = 65